<template>
  <div class="row">
    <div class="col-xl-12">
      <h2 class="text-dark">Gestión de Planes</h2>
    </div>
    <div class="col-lg-4 col-sm-4">
      <div class="card shadow">
        <my-spinner :loading="loadingPlanes" />

        <div v-show="!loadingPlanes" class="card-body text-center">
          <p>Para comenzar, selecciona un plan del listado</p>

          <div class="form-group mb-2">
            <select
              class="form-control"
              id="exampleFormControlSelect1"
              @change="setSelectedPlan()"
              v-model="idPlan"
            >
              <option value="0">Seleccionar Plan</option>
              <template v-for="plan in planes">
                <option
                  :key="plan.id"
                  :value="plan.id"
                >{{plan.name}} {{ !plan.active ? "(Inactivo)":"" }}</option>
              </template>
            </select>
          </div>
          <div v-if="actions.post">
            <p>ó</p>
            <button class="btn btn-success btn-xs" @click="toggleForm">
              <i class="fa fa-plus-circle text-success"></i> crea uno nuevo
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-sm-8 fadeInUp" v-if="showForm">
      <div class="card border-0">
        <div
          class="card-header text-white"
          v-text="selectedPlan.id == 0 ? 'Crear nuevo Plan': 'Estás en modo edición'"
          :class="selectedPlan.id == 0 ? 'bg-success': 'bg-info'"
        ></div>

        <div class="card-body p-relative">
          <form @submit.prevent="handleSetPlan">
            <div class="alert alert-secondary shadow" v-if="!selectedPlan.active">
              <h4>
                <i class="fa fa-exclamation-triangle mr-2 text-danger fadeIn"></i>
                Plan configurado como
                <u>Inactivo</u>
                <template v-if="selectedPlan.active != tmpPlan.active">
                  <br />
                  <small class="text-muted text-xs">Debes guardar cambios para hacerlo efectivo.</small>
                </template>
              </h4>
            </div>
            <div class="form-group">
              <label class="text-xs text-muted" for>Nombre del Plan</label>

              <input
                :disabled="loading"
                type="text"
                class="form-control"
                v-model="selectedPlan.name"
              />
            </div>
            <div class="form-group">
              <label class="text-xs text-muted" for>Cantidad avisos</label>
              <input
                :disabled="loading"
                type="number"
                class="form-control"
                v-model="selectedPlan.quantity"
                minlength="1"
              />
              <span
                class="text-xs text-danger"
                v-if="!validQuantity"
              >El valor debe ser mayor o igual a cero.</span>
            </div>
            <div class="form-group">
              <label class="text-xs text-muted" for>
                Cantidad Premium
                <span
                  v-if="calculatePremium > 0"
                  class="text-primary m-2"
                >(10% recomendado: {{calculatePremium}} )</span>
              </label>
              <input
                :disabled="loading || !validQuantity"
                type="number"
                class="form-control"
                minlength="0"
                v-model="selectedPlan.premium"
              />
              <span class="text-xs text-muted">No debe superar la cantidad de avisos contratados</span>
              <span class="text-xs text-danger" v-if="!validPremium">
                <br />Valor Premium inválido
              </span>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  class="custom-control-input"
                  id="customCheck2"
                  type="checkbox"
                  v-model="selectedPlan.active"
                  :disabled="loading || !actions.put"
                />
                <label class="custom-control-label" for="customCheck2">Activar plan</label>
              </div>
            </div>

            <div class="form-group text-right">
              <div class="alert alert-danger text-center" v-if="error">Hubo un error</div>
              <button
                type="button"
                class="btn btn-secondary"
                @click="cancelEdition"
                :disabled="loading"
              >Cancelar</button>

              <button
                v-if="actions.put"
                type="submit"
                :disabled="!validPlan || loading"
                class="btn"
                v-text="selectedPlan.id == 0 ? 'Guardar': 'Actualizar'"
                :class="selectedPlan.id == 0 ? 'btn-success': 'btn-info'"
              >Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <template v-if="selectedPlan.products">
      <PlanAsociacion :actions="actions" :products="selectedPlan.products" />
    </template>
  </div>
</template>
<script>
import { Plan } from "./models/model";
import Auth from "@/helpers/middleware";
import PlanAsociacion from "./PlanAsociacion";
import dealersService from "@/services/dealers.services";
import sysMsgs from "@/helpers/system.message";

export default {
  name: "Planes",
  components: {
    PlanAsociacion
  },
  data() {
    return {
      showForm: false,
      selectedPlan: new Plan(),
      idPlan: 0,
      error: false,
      loading: false,
      actions: Auth.getActions(this.$route.name),
      user: Auth.getUser(),
      planes: [],
      loadingPlanes: false,
      recommendedPremium: 0,
      tmpPlan: new Plan()
    };
  },
  created() {
    this.getPlanes();
  },
  methods: {
    getPlanes() {
      this.loadingPlanes = true;
      dealersService.admin
        .getPlanes()
        .then(response => {
          this.planes = response.data;
        })
        .catch(error => {
          console.log("error", error);
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loadingPlanes = false;
        });
    },
    getSinglePlan(id) {
      this.loading = true;
      dealersService.admin
        .getPlanes(id)
        .then(response => {
          this.selectedPlan = response.data[0];
          this.tmpPlan = response.data[0];
          this.planes.push(response.data[0]);
          sysMsgs.getMessage("Agregado con éxito.", "success");
        })
        .catch(error => {
          console.log("error", error);
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loadingPlanes = false;
        });
    },
    cancelEdition() {
      this.idPlan = 0;
      this.showForm = false;
      this.selectedPlan = new Plan();
      this.tmpPlan = new Plan();
    },
    setSelectedPlan() {
      let plan = this.planes.find(plan => plan.id == this.idPlan);

      if (plan) {
        this.selectedPlan = { ...plan };
        this.tmpPlan = { ...plan };
        this.showForm = true;
      } else {
        this.selectedPlan = new Plan();
        this.tmpPlan = new Plan();
        this.showForm = false;
      }
    },
    handleSetPlan() {

      if (this.planes.some(item => item.quantity == this.selectedPlan.quantity && item.premium == this.selectedPlan.premium && item.id != this.selectedPlan.id)) {
        sysMsgs.getMessage(
          "Ya existe un plan con características similares.",
          "error"
        );
        return;
      }


      if (!this.validPlan) {
        sysMsgs.getMessage(
          "Verifíca todos los campos antes de guardar.",
          "error"
        );
        return;
      }


      let msg = {};
      msg.text = this.selectedPlan.id == 0 ? "crear un nuevo" : "editar el";
      msg.type = this.selectedPlan.id == 0 ? "question" : "warning";
      sysMsgs
        .getConfirm(
          `¿Está seguro que quiere ${msg.text} plan?`,
          msg.type,
          "Confirmar acción"
        )
        .then(result => {
          if (result.value) {
            if (
              this.selectedPlan.products &&
              this.selectedPlan.products.length > 0
            ) {
              this.selectedPlan.products.map(i => (i.user = this.user.email));
            }

            this.setPlan();
          }
        });
    },
    setPlan() {
      this.loading = true;
      const _this = this;
      dealersService.admin
        .setPlan(this.selectedPlan)
        .then(response => {
          if (this.selectedPlan.id > 0) {
            let planes = _this.planes;
            let updatedPlanIndex = _this.planes.findIndex(
              plan => plan.id == _this.selectedPlan.id
            );
            planes[updatedPlanIndex] = { ...response.data };
            this.tmpPlan = { ...response.data };
            this.selectedPlan = { ...response.data };
            _this.planes = [...planes];
            sysMsgs.getMessage("Actualizado con éxito.", "success");
          } else {
            console.log(response.data);
            this.getSinglePlan(response.data.id);
          }
        })
        .catch(error => {
          console.log("error", error);
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleForm() {
      this.idPlan = 0;
      this.selectedPlan = new Plan();
      this.showForm = true;
    }
  },
  computed: {
    calculatePremium() {
      return Math.round(parseInt(this.selectedPlan.quantity) * 0.1);
    },
    validName() {
      return this.selectedPlan.name.trim().length > 0;
    },
    validPremium() {
      return (
        (parseInt(this.selectedPlan.premium) == 0 &&
          parseInt(this.selectedPlan.quantity) == 0) ||
        (parseInt(this.selectedPlan.premium) >= 0 &&
          parseInt(this.selectedPlan.premium) <
            parseInt(this.selectedPlan.quantity))
      );
    },
    validQuantity() {
      return parseInt(this.selectedPlan.quantity) >= 0;
    },
    validPlan() {
      return this.validName && this.validQuantity && this.validPremium;
    }
  }
};
</script>
<style lang="scss">
.tab-pane {
  outline: none !important;
}
</style>